import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

import { addLeadingZeros } from '@shared-submodule/utils'

const Timer = ({ timer }) => {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center h-100'>
      <p className={`${styles.title} mb-2 big-text font-bold`}>{'This Match Will Start In'}</p>
      <div className='d-flex flex-column theme-text-bright'>
        <h1 className="d-flex gap-3 mb-0">
          {
            timer?.days > 0 && (
              <>
                <span className={styles.day}>{addLeadingZeros(timer?.days)}</span>:
              </>
            )
          }
          <span className={styles.sec}>{addLeadingZeros(timer?.hours)}</span>:<span className={styles.sec}>{addLeadingZeros(timer?.min)}</span>
          {
            timer?.days < 1 && (
              <>
                : <span className={styles.sec}>{addLeadingZeros(timer?.sec)}</span>
              </>
            )
          }
        </h1>
        <p className={`d-flex justify-content-between gap-md-4 mb-0 ${timer?.days < 1 ? 'px-1' : ''} text-uppercase`}>
          {
            timer?.days > 0 && (
              <span className={timer?.days > 99 ? 'ps-1' : ''}>{'Days'}</span>
            )
          }
          <span>{'Hrs'}</span>
          <span className={timer?.days > 99 ? 'pe-2' : timer?.days < 1 ? 'pe-1' : 'pe-2'}>{'Mins'}</span>
          {timer?.days < 1 && (
            <span className='pe-md-1 pe-1'>{'Sec'}</span>
          )}
        </p>
      </div>
    </div>
  )
}

Timer.propTypes = {
  timer: PropTypes.object
}

export default Timer
